export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/notice/query`,
          data
        });
      },
      list(data){
          return http.json({
              url: `/notice/backList`,
              data
          });
      },
      /**
       * 保存公告信息
       * @param data
       * @return {*}
       */
      saveNoticeInfo(data) {
          return http.json({
              url: '/notice/save',
              data
          })
      },
      /**
       * 获取公告详情
       * @param data
       * @return {*}
       */
      getNoticeInfo(data) {
          return http.json({
              url: `/notice/get?id=${data.id}&type=web`
          })
      },
      /**
       * 删除公告
       * @param data
       * @return {*}
       */
      removeNotice(data) {
          return http.json({
              url: `/notice/delete?id=${data[0].id}`,
              data
          })
      },

      /**
       * 隐藏或显示公告
       * @param data
       * @return {*}
       */
      showOrHidden(data) {
        return http.json({
            url: `/notice/showOrHidden?id=${data.id}&state=${data.state}`,
            data
        })
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/notice.js